export default "__VITE_ASSET__wEbWJDA1__"